export const collectionEventsConfig = {
    parentSelector: '.main-collection-product-grid-section', // Added top-level parent selector for Collection Pages
    // parentSelector: '[id*="shopify-section-template"][id*="__banner"], collection__description', // Scoped to the banner section containing the slider
    events: {
        // Collections | click on collection in collection slider (CSV Line 70)
        // MOVED TO collectionSliderEventsConfig.js
        /*
        collectionIconSliderItemClick: {
            selector: '.collection-icon__slider .collection-icon__item__info a',
            event: {
                event: 'collections',
                component: 'collection_slider',
                element: 'item',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const collectionName = element.textContent.trim();
                    return {
                        collection_name: collectionName,
                        link_url: element.href
                    };
                }
            }
        },
        */

        // Collections | click on slider button (CSV Line 71)
        // MOVED TO collectionSliderEventsConfig.js
        /*
        collectionIconSliderButtonClick: {
            selector: '.collection-icon__slider-button.slider-button', // Corrected selector for prev/next buttons
            event: {
                event: 'collections',
                component: 'collection_slider',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    // No specific dynamic data requested in CSV for this generic button click
                    // We could add 'action_value: element.name' (next/previous) if needed
                })
            }
        },
        */

        // Collections | click on link in text (CSV Line 72)
        collectionDescriptionLinkClick: {
             // Selector targets links within the collection description area
            selector: '.collection__description a',
            event: {
                event: 'collections',
                component: 'collection_description', // Assuming component based on context
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        // CSV Line 36: Collections | click on button hide/show filter
        filterToggleButton: {
            selector: 'button.facets-active-toolbar__toggle-filter',
            event: {
                event: 'collection', // Changed from 'search' to 'collection'
                component: 'filter',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Get text from the appropriate span based on visibility
                    const showText = element.querySelector('.show-filter-text')?.textContent.trim() || 'Show filter';
                    const hideText = element.querySelector('.hide-filter-text')?.textContent.trim() || 'Hide filter';
                    
                    // Determine state based on the class of the parent container
                    const facetsVertical = element.closest('.facets-vertical'); 
                    const isShowingFilters = !facetsVertical?.classList.contains('facets-vertical--hide-filter');
                    
                    // Return the text of the action that will occur (Show or Hide)
                    return { click_text: isShowingFilters ? hideText : showText }; 
                }
            }
        },

        // ========================================
        // == Filter Events (Collection Page) =====
        // ========================================

        // CSV Line 37: Collections | filter accordion open/close 
        filterAccordionToggle: {
            selector: 'details.facets__details summary.facets__summary', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'accordion',
                action: 'click', // Simplified
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details');
                    const isOpen = detailsElement?.hasAttribute('open');
                    const labelElement = element.querySelector('.facets__summary__label');
                    return {
                        field_name: labelElement ? labelElement.textContent.trim() : 'Unknown Filter',
                        action: isOpen ? 'close' : 'open' // State *after* click
                    };
                }
            }
        },

        // CSV Line 38: Collections | filter checkbox on/off
        filterCheckboxToggle: {
            selector: '#FacetFiltersForm input[type="checkbox"].facets__checkbox-value, #FacetFiltersFormMobile input[type="checkbox"].facets__checkbox-value',
            event: {
                event: 'collection',
                component: 'filter',
                element: 'checkbox',
                action: 'click', // Simplified
                trigger: 'change',
                getDynamicData: (element) => {
                    const labelElement = element.closest('label.facet-checkbox')?.querySelector('.facet-checkbox__content__label');
                    const accordionSummary = element.closest('details.facets__details')?.querySelector('summary .facets__summary__label');
                    return {
                        field_name: accordionSummary ? accordionSummary.textContent.trim() : 'Unknown Filter',
                        checkbox_value: labelElement ? labelElement.textContent.trim() : 'Unknown Value',
                        action: element.checked ? 'on' : 'off' // State *after* change
                    };
                }
            }
        },

        // CSV Line 39: Collections | filter select with slider (Price Range)
        filterPriceRangeSelect: {
            selector: 'price-range input[type="range"]', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'slider',
                field_name: 'Prijs', // Static for price slider
                action: 'select',
                trigger: 'change',
                getDynamicData: (element) => {
                    const priceRangeElement = element.closest('price-range');
                    const fromValue = priceRangeElement?.querySelector('.facets__price__range-value--from')?.textContent.trim();
                    const toValue = priceRangeElement?.querySelector('.facets__price__range-value--to')?.textContent.trim();
                    return {
                        select_value: `Prijs: ${fromValue || '€?.??'} - ${toValue || '€?.??'}` 
                    };
                }
            }
        },

        // CSV Line 40: Collections | filter click on view more/less options
        filterShowMoreLess: {
            selector: 'details.facets__details .facets__display button.button-show-more', // Slightly more specific selector
            event: {
                event: 'collection',
                component: 'filter',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details.facets__details');
                    const filterName = detailsElement?.querySelector('summary .facets__summary__label')?.textContent.trim();
                    const showMoreSpan = element.querySelector('.label-show-more');
                    const showLessSpan = element.querySelector('.label-show-less');
                    let clickText = 'Meer weergeven'; // Default value
                    // FLIPPED LOGIC (assuming timing issue like search)
                    if (showLessSpan && !showLessSpan.classList.contains('hidden')) {
                        clickText = showMoreSpan?.textContent.trim() || 'Meer weergeven';
                    } else if (showMoreSpan && !showMoreSpan.classList.contains('hidden')) {
                        clickText = showLessSpan?.textContent.trim() || 'Minder weergeven';
                    }
                    return {
                        field_name: filterName || 'Unknown Filter',
                        click_text: clickText
                    };
                }
            }
        },

        // CSV Line 41/42/43: Collections | filter modal open/close/cta (Mobile)
        filterModalMobileToggle: {
            selector: 'details.mobile-facets__disclosure summary.mobile-facets__open-wrapper', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'modal',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details');
                    const isOpen = detailsElement?.hasAttribute('open');
                    const buttonText = element.querySelector('.mobile-facets__open-label')?.textContent.trim() || 'Filteren en sorteren';
                    return {
                        action: isOpen ? 'close' : 'open', // State *after* click
                        click_text: buttonText
                    };
                }
            }
        },
        filterModalMobileClear: {
            selector: 'facet-remove.mobile-facets__clear-wrapper a.mobile-facets__clear', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim() || 'Alles verwijderen'
                })
            }
        },
        filterModalMobileApply: {
            selector: '.mobile-facets__footer button.button--primary', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim() || 'Toepassen'
                })
            }
        },

        // CSV Line 44: Collections | Remove filter/all filters (Desktop)
        filterRemoveSingle: {
            selector: 'facet-remove a.active-facets__button', // Same as search
            event: {
                event: 'collection',
                component: 'filter',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim() // E.g., "Merk: Bsi"
                })
            }
        },

        // ==========================================
        // == Sorting Events (Collection Page) ======
        // ==========================================

        // CSV Line 45/46/47: Collections | dropdown relevance open/close/select
        sortingDropdownToggleDesktop: {
            selector: 'details.facet-filters__field__details[data-sort="SortByDesktop"] summary.disclosure__button', // Same as search
            event: {
                event: 'collection',
                component: 'sorting',
                element: 'dropdown',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details');
                    const isOpen = detailsElement?.hasAttribute('open');
                    return {
                        field_name: 'Relevantie', // Assuming this is the default/main sort label
                        action: isOpen ? 'close' : 'open' // State *after* click
                    };
                }
            }
        },
        sortingDropdownSelectDesktop: {
            selector: 'ul#SortByDesktopList button.facet-checkbox--sort-button', // Same as search
            event: {
                event: 'collection',
                component: 'sorting',
                element: 'dropdown',
                action: 'select',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field_name: 'Relevantie', // Main sort label
                    dropdown_select_value: element.textContent.trim()
                })
            }
        },
        sortingSelectMobile: {
            selector: 'select#SortBy-mobile', // Same as search
            event: {
                event: 'collection',
                component: 'sorting',
                element: 'dropdown',
                action: 'select',
                trigger: 'change',
                getDynamicData: (element) => {
                    const selectedOption = element.options[element.selectedIndex];
                    return {
                        field_name: 'Relevantie', // Main sort label
                        dropdown_select_value: selectedOption ? selectedOption.text : ''
                    };
                }
            }
        },

        // ============================================
        // == Pagination Events (Collection Page) ====
        // ============================================

        // CSV Line 48/49/50: Collections | pagination click on arrow > / < / number
        paginationClick: {
            selector: 'nav.pagination a.pagination__item', // Same as search
            event: {
                event: 'collection',
                component: 'pagination',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    let elementType = 'unknown';
                    let actionValue = element.textContent.trim();
                    let pageNumber = undefined;

                    if (element.classList.contains('pagination__item--prev')) {
                        elementType = 'chevron';
                        actionValue = 'previous';
                    } else if (element.classList.contains('pagination__item--next')) {
                        elementType = 'chevron';
                        actionValue = 'next';
                    } else if (element.classList.contains('pagination__item--number')) {
                        elementType = 'number';
                        pageNumber = actionValue; // Page number is the text content
                        actionValue = undefined; // No specific action value needed for number clicks
                    }
                    
                    return {
                        element: elementType,
                        page_number: pageNumber,
                        action_value: actionValue
                    };
                }
            }
        }

        // Add other collection page events here later
    }
}; 